import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { photographerLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error('Authentication failed');
        navigate('/');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        await photographerLogin(sessionId);
        toast.success('Welcome, photographer!');
        // Clear the hash and navigate
        window.history.replaceState(null, '', '/photographer/dashboard');
        navigate('/photographer/dashboard', { replace: true });
      } catch (error) {
        toast.error('Authentication failed');
        navigate('/photographer/login');
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" style={{ width: 40, height: 40 }} />
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
